import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import data from '../../../swagger-specs/api.yaml';
import ModelDefinitions from "../../components/model-definitions";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "api-model-definitions"
    }}>{`API Model Definitions`}</h1>
    <h2 {...{
      "id": "programs"
    }}>{`Programs`}</h2>
    <ModelDefinitions data={data} sort={true} forTag="Programs" mdxType="ModelDefinitions" />
    <h2 {...{
      "id": "repositories"
    }}>{`Repositories`}</h2>
    <ModelDefinitions data={data} sort={true} forTag="Repositories" mdxType="ModelDefinitions" />
    <h2 {...{
      "id": "branches"
    }}>{`Branches`}</h2>
    <ModelDefinitions data={data} sort={true} forTag="Branches" mdxType="ModelDefinitions" />
    <h2 {...{
      "id": "pipelines"
    }}>{`Pipelines`}</h2>
    <ModelDefinitions data={data} sort={true} forTag="Pipelines" mdxType="ModelDefinitions" />
    <h2 {...{
      "id": "pipeline-execution"
    }}>{`Pipeline Execution`}</h2>
    <ModelDefinitions data={data} sort={true} forTag="Pipeline Execution" exclusions={['Redirect']} mdxType="ModelDefinitions" />
    <h2 {...{
      "id": "environments"
    }}>{`Environments`}</h2>
    <ModelDefinitions data={data} sort={true} forTag="Environments" exclusions={['BadRequestError', 'Redirect']} mdxType="ModelDefinitions" />
    <h2 {...{
      "id": "region-deployment"
    }}>{`Region Deployment`}</h2>
    <ModelDefinitions data={data} sort={true} forTag="Region Deployments" exclusions={['BadRequestError', 'Redirect']} mdxType="ModelDefinitions" />
    <h2 {...{
      "id": "variables"
    }}>{`Variables`}</h2>
    <ModelDefinitions data={data} sort={true} forTag="Variables" mdxType="ModelDefinitions" />
    <h2 {...{
      "id": "ip-allowlist"
    }}>{`IP Allowlist`}</h2>
    <ModelDefinitions data={data} sort={true} forTag="IP Allowlist" mdxType="ModelDefinitions" />
    <h2 {...{
      "id": "ip-allowlist-binding"
    }}>{`IP Allowlist Binding`}</h2>
    <ModelDefinitions data={data} sort={true} forTag="IP Allowlist Binding" mdxType="ModelDefinitions" />
    <h2 {...{
      "id": "domain-names"
    }}>{`Domain Names`}</h2>
    <ModelDefinitions data={data} sort={true} forTag="Domain Names" mdxType="ModelDefinitions" />
    <h2 {...{
      "id": "ssl-certificates"
    }}>{`SSL Certificates`}</h2>
    <ModelDefinitions data={data} sort={true} forTag="SSLCertificates" mdxType="ModelDefinitions" />
    <h2 {...{
      "id": "tenants"
    }}>{`Tenants`}</h2>
    <ModelDefinitions data={data} sort={true} forTag="Tenants" mdxType="ModelDefinitions" />
    <h2 {...{
      "id": "regions"
    }}>{`Regions`}</h2>
    <ModelDefinitions data={data} sort={true} forTag="Regions" mdxType="ModelDefinitions" />
    <h2 {...{
      "id": "network-infrastructure"
    }}>{`Network Infrastructure`}</h2>
    <ModelDefinitions data={data} sort={true} forTag="Network infrastructure" mdxType="ModelDefinitions" />
    <h2 {...{
      "id": "environment-advanced-networking-configuration"
    }}>{`Environment Advanced Networking Configuration`}</h2>
    <ModelDefinitions data={data} sort={true} forTag="Environment Advanced Networking Configuration" exclusions={['Environment']} mdxType="ModelDefinitions" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      